module.exports = __webpack_public_path__ + "static/media/o25.8cacd7fd.png";